// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginPageMobile_container__X35hk","title":"LoginPageMobile_title__1GcPz"};